import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { QueryString } from '@grandvisionhq/utils';
import ErrorBoundary from '../../../../components/ErrorBoundary/ErrorBoundary.js';
import useClientSideRouter from '../../../../hooks/use-client-side-router.js';
import { RoutingError } from '../../errors.js';
import { CancelAppointmentProvider } from '../provider.js';
import { RoutingContext } from './context.js';

const RoutingContextProvider = ({ routeMap , initialRoutingState , initialState , children ,  })=>{
    const { Provider  } = RoutingContext;
    const { basePath , currentRoute: initialRoute , queryParams: initialQueryParams ,  } = initialRoutingState;
    const [{ goTo  }, { queryParams: queryParams1 , currentRoute  }] = useClientSideRouter({
        basePath,
        initialRoute,
        initialQueryParams
    });
    const goToHandler = React.useCallback((route, queryParams)=>{
        const newQueryParams = swcHelpers.objectSpread({}, queryParams);
        Object.keys(newQueryParams).forEach((key)=>newQueryParams[key] === undefined ? delete newQueryParams[key] : {}
        );
        goTo(`${basePath}/${route}${QueryString.stringify(newQueryParams)}`);
    }, [
        basePath,
        goTo
    ]);
    const value = React.useMemo(()=>[
            {
                goTo: goToHandler
            },
            {
                component: routeMap[currentRoute],
                queryParams: queryParams1,
                currentRoute,
                basePath
            }, 
        ]
    , [
        routeMap,
        goToHandler,
        currentRoute,
        basePath,
        queryParams1
    ]);
    const Component = routeMap[currentRoute];
    return /*#__PURE__*/ React.createElement(Provider, {
        value: value
    }, /*#__PURE__*/ React.createElement(CancelAppointmentProvider, swcHelpers.extends({}, initialState), /*#__PURE__*/ React.createElement(ErrorBoundary, {
        bookAppointmentUrl: initialState.bookAppointmentUrl
    }, /*#__PURE__*/ React.createElement(Component, null))), children);
};
RoutingContextProvider.getServerSideProps = (currentRoute, routeMap /* locale */ )=>{
    const isValidRoute = currentRoute in routeMap;
    if (!isValidRoute) {
        throw new Error(RoutingError.INVALID_ROUTE);
    }
    if (currentRoute === 'confirmation') {
        throw new Error(RoutingError.SERVER_SIDE_CONFIRMATION_ATTEMPT);
    }
};

export { RoutingContextProvider };
//# sourceMappingURL=provider.js.map
